import { Injectable } from '@angular/core';
import { Response } from '@angular/http';
import { Observable } from 'rxjs/Observable';
import { BasicService } from '../../../providers/basic';
import { environment as config } from '../../../../environments/environment';
import { TranslateService } from '@ngx-translate/core';
import { AuthHttp } from 'angular2-jwt';
import { AuthService } from '../../auth/auth.service';
import { FormBuilder, Validators } from '@angular/forms';
import { empty, merge } from 'ramda/es';
import { assoc } from 'ramda';
import 'rxjs/add/operator/map';
import 'rxjs/add/operator/catch';
import { ISession } from '../../../models/session';


const generatePassword = (length = 12, useUpper = true, useNumbers = true, useSymbols = true) => {
  const lowerCharacters = ['a', 'b', 'c', 'd', 'e', 'f', 'g', 'h', 'i', 'j', 'k', 'l', 'm', 'n', 'o', 'p', 'q', 'r', 's', 't', 'u', 'v', 'w', 'x', 'y', 'z'];
  const upperCharacters = ['A', 'B', 'C', 'D', 'E', 'F', 'G', 'H', 'I', 'J', 'K', 'L', 'M', 'N', 'O', 'P', 'Q', 'R', 'S', 'T', 'U', 'V', 'W', 'X', 'Y', 'Z'];
  const numbers = ['0', '1', '2', '3', '4', '5', '6', '7', '8', '9'];
  const symbols = ['!', '?', '@'];
  const getRandom = (array) => {
    return array[Math.floor(Math.random() * array.length)];
  }
  let finalCharacters = '';
  if (useUpper) {
    finalCharacters = finalCharacters.concat(getRandom(upperCharacters));
  }
  if (useNumbers) {
    finalCharacters = finalCharacters.concat(getRandom(numbers));
  }
  if (useSymbols) {
    finalCharacters = finalCharacters.concat(getRandom(symbols));
  }
  for (var i = 1; i < length - 2; i++) {
    finalCharacters = finalCharacters.concat(getRandom(lowerCharacters));
  }
  //shuffle!
  return finalCharacters.split('').sort(function () {
    return 0.5 - Math.random()
  }).join('');
}

@Injectable()
export class UsersService extends BasicService {
  private API = config.sessions.url;
  private USER_API = config.users.url;
  public sessionForm = this.fb.group({
    name: ['', Validators.required],
    date: ['', Validators.required],
    description: ['', Validators.minLength(5)],
    shortUrl: ['']
  });

  constructor(
    protected auth: AuthService,
    protected translate: TranslateService,
    private http: AuthHttp,
    private fb: FormBuilder
  ) {
    super(auth, translate);
  }

  public getSpecialUsers(id: string, notify: boolean = false) {
    return this.http
      .get(`${this.USER_API}/sessions/${id}/users/specials`)
      .map(res => this.extractData(res, notify))
      .catch(err => this.handleError(err));
  }

  public addSpecialUsers(
    id: string,
    type: 'guest' | 'moderator' | 'powerUser' | 'videoOperator',
    data,
    notify: boolean = true
  ) {
    return this.http
      .post(`${this.USER_API}/sessions/${id}/users/specials/${type}`, assoc('password', generatePassword(), data))
      .map(res => this.extractData(res, notify))
      .catch(err => this.handleError(err));
  }

  public editSpecialUsers(id: string, data, notify: boolean = true) {
    return this.http
      .put(`${this.USER_API}/sessions/${id}/users/specials/any`, data)
      .map(res => this.extractData(res, notify))
      .catch(err => this.handleError(err));
  }

  public getRegistration(id: string, notify: boolean = false) {
    return this.http
      .get(`${this.USER_API}/sessions/${id}/users/forms/registration`)
      .map(res => this.extractData(res, notify))
      .catch(err => this.handleError(err));
  }

  public updateRegistration(session: ISession, data, notify: boolean = true) {
    return this.http
      .post(`${this.USER_API}/sessions/${session.id}/users/forms/registration`, data)
      .map(res => this.extractData(res, notify))
      .catch(err => {
        if (err.status === 409) {
          toastr.error(this.translate.instant('action.alreadyFilled'));
          return err;
        }
        return this.handleError(err);
      });
  }

  public getGenericLogin(id: string, notify: boolean = false) {
    return this.http
      .get(`${this.USER_API}/sessions/${id}/users/forms/unique`)
      .map(res => this.extractData(res, notify))
      .catch(err => this.handleError(err));
  }

  public updateGenericLogin(session: ISession, data, notify: boolean = true) {
    return this.http
      .post(`${this.USER_API}/sessions/${session.id}/users/forms/unique`, data)
      .map(res => this.extractData(res, notify))
      .catch(err => this.handleError(err));
  }
}



// WEBPACK FOOTER //
// ./src/app/modules/sessions/users/users.service.ts